import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { translations } from "../../utils/translations";

const Footer = () => {
  // Logica del idioma
  const currentLang = localStorage.getItem("language") || "es";
  const t = translations[currentLang]?.footer || translations["es"].footer;

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section about">
          <h2>RepliKers</h2>
          <p>{t.slogan}</p>
        </div>
        <div className="footer-section links">
          <h3>{t.socialMedia}</h3>
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/company/replikers/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section contact">
          <h3>{t.contactUs}</h3>
          <p>+1 (415) 604-6499</p>
          <p>hola@replikers.com</p>
        </div>
        <div className="footer-section links">
          <h3>{t.quickLinks}</h3>
          <ul>
            <li>
              <Link to="/replikers">{t.replikersList}</Link>
            </li>
            <li>
              <Link to="/blog">{t.blog}</Link>
            </li>
            <li>
              <Link to="/social">{t.social}</Link>
            </li>
            <li>
              <Link to="/about">{t.aboutUs}</Link>
            </li>
            <li>
              <Link to="/privacy">{t.privacyPolicy}</Link>
            </li>
            <li>
              <Link to="/terms">{t.termsOfService}</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; 2024 - 2025 {t.copyText} {t.company}
      </div>
    </footer>
  );
};

export default Footer;
